export default {
  beta: 'Beta',
  actions: {
    send: 'ส่ง',
    verify: 'ยืนยัน',
    resend: 'ส่ง OTP อีกครั้ง',
    logout: 'ออกจากระบบ',
    pay: 'ชำระเงิน',
    submit: 'ส่ง',
    back: 'ย้อนกลับ',
    cancel: 'ยกเลิก',
    retry: 'ลองอีกครั้ง',
    add_photo: 'เพิ่มรูปภาพ',
  },
  status: {
    loading: 'กำลังโหลด...',
    error: 'เกิดข้อผิดพลาด',
    success: 'สำเร็จ',
    pending: 'รอรับ',
    collected: 'รับแล้ว',
    paid: 'ชำระแล้ว',
    unpaid: 'ยังไม่ชำระ',
    overdue: 'เกินกำหนด',
    open: 'เปิด',
    in_progress: 'กำลังดำเนินการ',
    completed: 'เสร็จสิ้น',
  },
  nav: {
    home: 'หน้าหลัก',
    invoices: 'ใบแจ้งหนี้',
    maintenance: 'แจ้งซ่อม',
    parcels: 'พัสดุ',
    vehicles: 'ยานพาหนะ',
    rewards: 'รางวัล',
    // EP-135 Tier 1a — bottom-nav tab for shared-owner / dual-role persons.
    meetings: 'การประชุม',
  },
  // EP-135 Tier 1a — used in MeetingsPage header for the owned-unit count.
  meetings_owned_units_one: '1 หน่วยที่ถือครอง',
  meetings_owned_units_other: '{{count}} หน่วยที่ถือครอง',
  errors: {
    required: 'กรุณากรอกข้อมูล',
    something_went_wrong: 'เกิดข้อผิดพลาด กรุณาลองอีกครั้ง',
    liff_not_configured: 'แอปนี้ยังไม่ได้ตั้งค่าสำหรับบัญชีใดๆ',
    network_error: 'เกิดข้อผิดพลาดทางเครือข่าย กรุณาตรวจสอบการเชื่อมต่อ',
    not_in_line_title: 'กรุณาเปิดในแอป LINE',
    not_in_line_subtitle: 'แอปนี้ออกแบบมาสำหรับใช้งานภายใน LINE กรุณาเปิดลิงก์นี้จากแอป LINE',
  },
}
